import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownItem } from '@libs/ui-lib';
import { DateTime } from 'luxon';
import { ProvisionalStatus } from '@ffd/api-client';
import {
  HealthHistoryItemDeleteData,
  HealthHistoryItemEditComponent,
  HealthHistoryItemEditData,
} from '../health-history-item-edit/health-history-item-edit.component';
import { HealthHistoryItemDetailsComponent } from '../health-history-item-details/health-history-item-details.component';

export type ActiveStatus = 'active' | 'inactive';

export type CriticalStatus = 'critical' | 'non-critical';

export interface HealthHistoryItemVM {
  id: string;
  description: string;
  note: string;
  reportedDate: DateTime;
  startedDate: DateTime;
  inactivatedDate: DateTime | null;
  criticalStatus: CriticalStatus;
  activeStatus: ActiveStatus;
  provisionalStatus: ProvisionalStatus;
}

@Component({
  selector: 'lib-health-history-item',
  standalone: true,
  imports: [CommonModule, HealthHistoryItemEditComponent, HealthHistoryItemDetailsComponent],
  templateUrl: './health-history-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HealthHistoryItemComponent {
  public readonly healthHistoryItem = input.required<HealthHistoryItemVM>();
  public readonly dropdownOptions = input.required<DropdownItem<string>[]>();
  public readonly isEditMode = input.required<boolean>();
  public readonly isNewItem = input.required<boolean>();
  public readonly isLoading = input.required<boolean>();
  public readonly editHealthHistoryEnabled = input<boolean>(true);
  public readonly deleteHealthHistoryEnabled = input<boolean>(true);

  public changeEditMode = output<{ editMode: boolean; itemId: string }>();
  public deleteItem = output<HealthHistoryItemDeleteData>();
  public saveItem = output<HealthHistoryItemEditData>();
  public discardNewItem = output<void>();

  public setEditMode(editMode: boolean): void {
    this.changeEditMode.emit({ editMode, itemId: this.healthHistoryItem().id });
  }

  public onDeleteItem(event: HealthHistoryItemDeleteData): void {
    this.deleteItem.emit(event);
  }

  public onSaveItem(event: HealthHistoryItemEditData): void {
    this.saveItem.emit(event);
  }

  public onDiscardNewItem(): void {
    this.discardNewItem.emit();
  }
}
